import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router';
import { MenuTrigger, Button, Popover, Menu, MenuItem } from 'react-aria-components';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';



const BigMenu = () => {
	const { t } = useTranslation('web');

	const navigate = useNavigate();

	return (
		<div className='header-section big-menu-section'>
			<nav>
				<Link to={NavigateRoutesEnum.about} className='app-main-button disable-selection'>
					{t('layouts.header.aboutUs')}
				</Link>
			
				<MenuTrigger>

					<Button className='order-signpost-button app-main-button disable-selection' autoFocus={false}>
						{t('shared.orderLong')}
					</Button>

					<Popover>
						<Menu onAction={(key: string | number) => navigate(String(key))} autoFocus={false}>

							<MenuItem id={NavigateRoutesEnum.order} textValue={t('layouts.header.dogForm')}>
								<Link to={NavigateRoutesEnum.order}>{t('layouts.header.dogForm')}</Link>
							</MenuItem>

							<MenuItem id={NavigateRoutesEnum.catOrder} textValue={t('layouts.header.catForm')}>
								<Link to={NavigateRoutesEnum.catOrder}>{t('layouts.header.catForm')}</Link>
							</MenuItem>

						</Menu>
					</Popover>
				</MenuTrigger>
			
				<Link to={NavigateRoutesEnum.gallery} className='app-main-button disable-selection'>
					{t('layouts.header.gallery')}
				</Link>
			
				<Link to={NavigateRoutesEnum.partners} className='app-main-button disable-selection'>
					{t('layouts.header.forPartners')}
				</Link>

				<Link to={NavigateRoutesEnum.faq} className='app-main-button disable-selection'>
					{t('layouts.header.faq')}
				</Link>

				<Link to={NavigateRoutesEnum.salesNetwork} className='app-main-button disable-selection'>
					{t('layouts.header.salesNetwork')}
				</Link>
			</nav>
		</div>
	);
}

export default BigMenu;